// src/components/common/Toast.js
import React from "react";
import { useToast } from "../../contexts/ToastContext";

export default function Toast() {
  const { toast } = useToast();

  const getBgColor = () => {
    switch (toast.type) {
      case "e":   // error
        return "bg-red-500";
      case "i":   // info / success
        return "bg-teal-500";
      case "w":   // warning
        return "bg-yellow-500";
      default:
        return "bg-gray-700"; // 기본값
    }
  };

  return (
    <div
      className={`fixed bottom-0 left-0 right-0 p-4 transition-all duration-300 pointer-events-none z-50
      ${toast.isVisible ? "translate-y-0" : "translate-y-full"}`}
    >
      <div
        className={`mx-auto max-w-sm rounded-lg shadow-xl px-4 py-3 text-white ${getBgColor()}`}
      >
        <p className="font-medium text-center">{toast.message}</p>
      </div>
    </div>
  );
}
